module.exports = __webpack_public_path__ + "static/media/test2_3.2a04241d.png";